import styled from 'styled-components'

import Button from 'components/Button'
import { Body, Heading2 } from 'components/Typography'
import { style } from 'theme'

export const Container = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
`

export const Title = styled(Heading2)`
  font-size: 16px;
  margin-bottom: 4px;
`

export const Subtitle = styled(Body)`
  margin: 0 auto 30px;
  max-width: 450px;
`

export const Disclaimer = styled(Body)`
  color: #707474;
  font-size: 12px;
  margin: 30px auto 50px;
  text-align: center;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    margin: 30px auto 40px;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin: 30px auto 30px;
  }
`

export const ButtonsContainer = styled.div`
  width: 100%;
  max-width: 280px;
  margin: 0 auto;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    max-width: 100%;
  }
`

export const StyledButton = styled(Button)`
  width: 100%;
  margin: 10px auto;
  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
`
